export const normalizeDomain = (domain) => {
  return domain
    .replace(/^https?:\/\//, "") // remove http:// or https://
    .replace(/^www\./, "") // remove www.
    .replace(/\/$/, "") // remove /
    .toLowerCase();
};
